module.exports = __webpack_public_path__ + "static/img/2.8a5ba70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/2.jpg
// module id = LwLP
// module chunks = 2